export default __webpack_public_path__ + "a74e4fb08bb15092d1c7b19f78bf14b6.jpeg";